import React from 'react';
import i18n from 'i18next';

import { type AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import en from './i18n/en';
import it from './i18n/it';

const ExchangeMailsLogsPage = lazyRetry(() => import('./ExchangeMailsLogsPage'));

i18n.addResourceBundle('en', 'core', en);
i18n.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ authorizer }) => authorizer.can('view', 'exchange_logs'),
	routes: [
		{
			path: 'exchange/mails/logs',
			element: <ExchangeMailsLogsPage />
		}
	]
};

export default routes;
